import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LNG } from './js/helpers/Localization';

import commonAU from './js/locales/en-AU/common.json';
import commonNZ from './js/locales/en-NZ/common.json';

const resources = {
    'en-AU': {
        common: commonAU,
    },
    'en-NZ': {
        common: commonNZ,
    },
};

i18n
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources,
        lng: LNG,
        fallbackLng: 'en-AU',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        // have a common namespace used around the full app
        ns: ['common'],
        defaultNS: 'common',
    });

export default i18n;
